import { Navigate, useNavigate } from 'react-router-dom';
import StageTagsDialog from '../../StageTagsDialog';
import { showToastError, showToastSuccess } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';
import { useSsoReauth } from '../../contexts/SsoReauthContext';
import { useStageTags, type UseStageTagsResult } from '../../hooks/usePackages';
import { usePackagesWizard } from './PackagesWizardContext';

// The staging wizard state does not survive the Metrc sign-in redirect, so the user restarts staging.
const STAGE_PATH = '/packages/stage';

export default function StageTagsContainer() {
  const navigate = useNavigate();
  const { org } = useLegacyAppSession();
  const { handleSsoError } = useSsoReauth();
  const {
    resetStageWizard,
    stageCandidates,
    stageSelection,
  } = usePackagesWizard();
  const stageTags = useStageTags({
    organizationId: Number(org?.id) || undefined,
    facilityId: stageSelection?.ridFacilityId,
    metrcFacilityId: stageSelection?.metrcFacilityId,
  });

  if (!stageSelection) {
    return <Navigate to="/packages/stage" replace />;
  }

  const submitStaging: UseStageTagsResult['submit'] = async (tags) => {
    const result = await stageTags.submit(tags);
    if (!result) return null;
    if (result.outcome === 'staged') {
      showToastSuccess('Tags added successfully');
      resetStageWizard();
      navigate('/packages', { replace: true });
    } else if (!(result.ssoError && handleSsoError(result.ssoError, { returnTo: STAGE_PATH }))) {
      showToastError('Error trying to stage packages');
    }
    return result;
  };

  return (
    <StageTagsDialog
      organizationId={Number(org?.id) || undefined}
      facilityId={stageSelection.ridFacilityId}
      facilityName={stageSelection.facilityName}
      marketId={stageSelection.marketId}
      marketName={stageSelection.marketName}
      tags={stageCandidates}
      staging={{ submit: submitStaging, isPending: stageTags.isPending }}
      onBack={() => navigate('/packages/stage', { replace: true })}
      onClose={() => {
        resetStageWizard();
        navigate('/packages', { replace: true });
      }}
      onNext={() => {}}
    />
  );
}
